import React, { ReactNode } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
// import { convertTimestampToDate } from '../../utils/helpers';

import MoodList from '../MoodList';

import './MediaDetails.scss';
import { TAccessServiceType } from '../../@types/Access';
import AccessibleFeatureList from '../AccessibleFeatureSection/AccessibleFeatureSection';

export interface IMediaDetailsProps {
  mediaType: 'movie' | 'series';
  title: string;
  imageUri: string;
  description: string;
  moods?: string[];
  statLine: ReactNode;
  preDescription?: ReactNode;
  postDescription?: ReactNode;
  useTitle?: boolean;
  dates: {
    startTime?: string;
    endTime?: string;
  };
  accessibleFeatures: TAccessServiceType[];
  accessServiceBadges?: ReactNode;
}

const MediaDetails = ({
  mediaType,
  title,
  imageUri,
  description,
  statLine,
  preDescription,
  postDescription,
  moods,
  useTitle,
  accessibleFeatures,
  accessServiceBadges,
}: IMediaDetailsProps) => {

  return (
    <article className="media-details">
      <div className="media-details__poster-container">
        <StaticImage
          className="triangle-pattern"
          src="../../../static/images/triangle_pattern.png"
          alt=""
          width={256}
          height={550}
          placeholder="tracedSVG"
        />
        <img
          src={imageUri}
          alt={`${title}`}
          className="media-details__poster"
        />
      </div>
      <div className="media-details__content">
        <h2 className="section-title">{useTitle ? title : 'Description'}</h2>

        {/* Media Stats (Genre, Runtime, Rating, etc) */}
        {statLine}

        {/* Pre-Description Content */}
        {!!preDescription && preDescription}

        {/* Description */}
        <div className="body">
          <p>{description}</p>
        </div>

        {/* Post-Description Content */}
        {!!postDescription && postDescription}

        {/* Moods */}
        {moods?.length ? <MoodList moods={moods} /> : null}

        {/* Access Service Badges */}
        {accessibleFeatures?.length ? (
          <AccessibleFeatureList
            accessibleFeatures={accessibleFeatures}
            mediaType={mediaType}
          />
        ) : null}
      </div>
    </article>
  );
};

export default MediaDetails;
